import { ValidatorFn, AbstractControl, ValidationErrors, UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';

export function comparisonDateValidator(startDate: string, endDate: string): ValidatorFn { 
  return (group: UntypedFormGroup): ValidationErrors => {
    const control1 = group.controls[startDate];
    const control2 = group.controls[endDate];    
    if (control1.value == null && control2.value !=null ) {
      control2.setErrors({ invalidDate: true });
      control2.markAsTouched();
    } else if (Date.parse(control1.value) > Date.parse(control2.value)) {
      control2.setErrors({ invalidDate: true });
      control2.markAsTouched();
    }else{
      control2.setErrors(null);
      }
    return;
  };
}

export function exactLengthValidator(length: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!length || !control.value) {
      return null;
    }
    const forbidden = control.value.length !== length;
    control.markAsTouched();
    return forbidden ? { exactLength: { value: control.value } } : null;
  };
}

export function requiredValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const forbidden = (!control.value);
    control.markAsTouched();
    return forbidden ? { required: { value: null } } : null;
  };
}

export function maxLengthValidator(length?: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!length || !control.value) {
      return null;
    }
    const forbidden = control.value.length > length;
    control.markAsTouched();
    return forbidden ? { maxLengthExceed: { value: control.value } } : null;
  };
}

export function noTwoWhiteSpacesValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const nameRe: RegExp = new RegExp('[ \t]{2,}');
    const forbidden = nameRe.test(control.value);
    control.markAsTouched();
    return forbidden ? { twoWhiteSpaces: { value: control.value } } : null;
  };
}

export function noWhiteSpacesValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const nameRe: RegExp = new RegExp('[ \t]{1,}');
    const forbidden = control.value !== null && nameRe.test(control.value);
    control.markAsTouched();
    return forbidden ? { whiteSpaces: { value: control.value } } : null;
  };
}

export function numbersValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const nameRe: RegExp = new RegExp('[0-9]*');
    const forbidden = control.value !== null && nameRe.test(control.value);
    control.markAsTouched();
    return forbidden ? { notANumbers: { value: control.value } } : null;
  };
}

export function nullValue(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    return control.value === null ? { nullValue: { value: control.value } } : null;
  };
}

export function NoFutureDateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const now = moment();
    const today = moment({ y: now.year(), M: now.month(), d: now.date(), h: 0, m: 0, s: 0, ms: 0 });
    const tomorrow = today.add(1, 'days');
    const difference = tomorrow.diff(control.value, 'minutes');
    const forbidden = difference <= 0;
    control.markAsTouched();
    return forbidden ? { NoFutureDate: { value: control.value, difference: difference } } : null;
  };
}

export function NoPresentFutureDateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const now = moment();
    const today = moment({ y: now.year(), M: now.month(), d: now.date(), h: 0, m: 0, s: 0, ms: 0 });
    const difference = today.diff(control.value, 'minutes');
    const forbidden = difference <= 0;
    control.markAsTouched();
    return forbidden ? { NoPresentFutureDate: { value: control.value, difference: difference } } : null;
  };
}

export function PercentageValidation(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const forbidden = isNaN(control.value) || control.value > 100 || control.value < 0;
    control.markAsTouched();
    return forbidden ? { NotAPercentageValue: { value: control.value } } : null;
  };
}

export function NineCharacterValidation(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!control.value) {
      return null;
    }
    const forbidden = control.value.length !== 9;
    control.markAsTouched();
    return forbidden ? { NotNingeCharacters: { value: control.value } } : null;
  };
}

export function PostalCodeValidation(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!control.value) {
      return null;
    }
    const forbidden = control.value.length !== 5;
    control.markAsTouched();
    return forbidden ? { NotAPostalCode: { value: control.value } } : null;
  };
}

export function LessThan80YearsValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const now = moment();
    const today = moment({ y: now.year(), M: now.month(), d: now.date(), h: 0, m: 0, s: 0, ms: 0 });
    const difference = today.diff(control.value, 'years');
    const forbidden = difference >= 80;
    control.markAsTouched();
    return forbidden ? { NoMoreThan80Years: { value: control.value, difference: difference } } : null;
  };
}

export function AdultValidation(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!control.value) {
      return;
    }
    const adultCompleteDate = control.value.clone() as moment.Moment;
    const now = moment();
    const today = moment({ y: now.year(), M: now.month(), d: now.date(), h: 0, m: 0, s: 0, ms: 0 });
    const forbidden = adultCompleteDate.isAfter(today);
    control.markAsTouched();
    return forbidden ? { NoAnAdult: { value: control.value } } : null;
  };
}

export function DateFormatValidation(control: AbstractControl): ValidationErrors | null {
  const inputValue = control.value;
  if (moment(inputValue, 'DD/MM/YYYY', true).isValid()) {
    return null;
  } else {
    return { DateFormatError: true };
  }
}

